










































import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import IndicatorSetServices, { IndicatorSetDto } from '@/services/indicatorSet';
import { checkCode } from '@/libs/util';
@Component
export default class IndicatorSets extends Vue {
  @PropSync('visible', { type: Boolean }) syncVisible!: boolean;
  @Prop() folderId!: number;
  @Prop() indSetId!: number;
  indSrv = new IndicatorSetServices();
  title: string = '新建指标集';

  @Watch('visible')
  async onVisibleChange() {
    if (this.indSetId > 0) {
      this.title = '编辑指标集';
      this.getInfo();
    } else {
      this.formData = {};
      this.title = '新建指标集';
    }
  }

  async getInfo() {
    this.formData = await this.indSrv.getInfo(this.indSetId);
  }

  formData: IndicatorSetDto = {};
  loading: boolean = false;
  async submit() {
    const must: { field: 'indSetCode' | 'indSetName'; msessage: string }[] = [
      { field: 'indSetCode', msessage: '指标集编码不能为空' },
      { field: 'indSetName', msessage: '指标集名称不能为空' }
    ];
    for (let val of must) {
      if (!this.formData[val.field]) {
        this.$message.error(val.msessage);
        return false;
      }
    }
    if (!checkCode(this.formData.indSetCode)) {
      this.$message.error('编码只能包含英文字母、数字、下划线');
      return false;
    }
    if (!this.indSetId) {
      let code = 'IND_SET_' + this.formData.indSetCode;
      let exist = await this.indSrv.getList({ indSetCode_eq: code });
      if (exist.length > 0) {
        this.$message.error(`编码[${code}]已经存在`);
        return false;
      }
    }
    this.loading = true;
    if (this.indSetId > 0) {
      let res = await this.indSrv.update(this.formData);
      this.formData = {};
      this.$emit('success', res);
    } else {
      let res = await this.indSrv.add({ ...this.formData, indSetCategoryId: this.folderId });
      this.formData = {};
      this.$emit('success', res);
    }
    this.$message.success('操作成功');
    this.syncVisible = false;
    this.loading = false;
  }

  close() {
    this.syncVisible = false;
    this.formData = {};
    this.$emit('success');
  }
}
